import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { createUseStyles } from "$utils/createUseStyles";

import { Link } from "react-router-dom";
import { publicIconPath } from "$utils/constants";
import BtnAuth from "./BtnAuth";
import BtnGroupCreation from "./BtnGroupCreation";
import SearchBar from "./SearchBar";
import { theme } from "$utils/theme/bataillog";

type Props = {
  isPublic?: boolean;
};

export default function ButtonAppBar({ isPublic = false }: Props) {
  const classes = useJssStyles();
  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.Toolbar}>
        {isPublic ? (
          <img
            alt="ico-batail"
            src={`${publicIconPath}/logo-linear.png`}
            className={classes.iconImg}
          />
        ) : (
          <Link to="/" className={classes.Link}>
            {}
            <img
              alt="ico-batail"
              src={`${publicIconPath}/logo-linear.png`}
              className={classes.iconImg}
            />
          </Link>
        )}
        {/* BL-565: temporary desactivate master search bar */}
        {!isPublic && (
          <>
            <div className={classes.separator} />
            <SearchBar />
            <BtnGroupCreation />
            <div className={classes.separator} />
            <BtnAuth />
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}

const useJssStyles = createUseStyles(() => ({
  appBar: {
    "&.MuiAppBar-root": {
      zIndex: 9990,
    },
  },
  root: {
    flex: "none",
  },
  Toolbar: {
    minHeight: "63px !important",
    background: theme.color.white,
  },
  title: {},
  Link: {
    color: "white",
    textDecoration: "unset",
    marginRight: theme.spacing(6),
    display: "flex",
  },
  iconImg: {
    height: 34,
  },
  separator: {
    width: 2,
    height: 16,
    background: theme.color.gray1,
  },
}));
